import { FC } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

import classes from "./Button.module.css";

interface Props {
  label: string;
  href: string;
  secondary?: boolean;
  disabled?: boolean;
  cancel?: boolean;
  small?: boolean;
}

const RouterButton: FC<Props> = ({
  label,
  href,
  secondary = false,
  disabled = false,
  cancel = false,
  small = false,
}) => {
  return (
    <Link
      className={`${classes.button} ${secondary ? classes.secondary : ""} ${
        cancel ? classes.cancel : ""
      } ${small ? classes.small : ""} ${disabled ? classes.disabled : ""}`}
      to={href}
    >
      {parse(label)}
    </Link>
  );
};

export default RouterButton;
